/** Fonte enviada pela aba "Fontes" dos banners (`GET internal/website/banner-fonts`). */
export interface IWebsiteFont {
  id: number
  name: string
  /** O que o editor escreve na classe do HTML (`ql-bannerfont-{slug}`). Não muda depois de criada. */
  slug: string
  url: string
  format: 'woff2' | 'woff' | 'ttf' | 'otf'
  /** Escala da fonte inteira, em % (`size-adjust` do `@font-face`). 100 é o desenho original. */
  size_adjust: number
}

/** Limites do `size_adjust`. Espelham o `between:50,250` da API. */
export const FONT_SIZE_ADJUST = { min: 50, max: 250, default: 100 }
